
      import API from "!../../../../vninvestcharts-widget/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../vninvestcharts-widget/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../../vninvestcharts-widget/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../../vninvestcharts-widget/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../../vninvestcharts-widget/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../../vninvestcharts-widget/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../../vninvestcharts-widget/node_modules/css-loader/dist/cjs.js!./advisory-panel.module.css";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../vninvestcharts-widget/node_modules/css-loader/dist/cjs.js!./advisory-panel.module.css";
       export default content && content.locals ? content.locals : undefined;
